/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ maxItems: NonNullable<unknown> }} Select_Up_ToInputs */

const en_select_up_to = /** @type {(inputs: Select_Up_ToInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Select <b>up to ${i?.maxItems}</b> soft skills that you <b>regularly demonstrate</b> and <b>can prove with practical examples</b>. Mark the appropriate boxes; no more than ${i?.maxItems} are possible. <br/>Prefer skills that you have <b>used in specific situations</b> (e.g., projects, tasks, achievements). Leave inapplicable ones blank; select "None" only if nothing applies.`)
};

const de_select_up_to = /** @type {(inputs: Select_Up_ToInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Wählen Sie <b>bis zu ${i?.maxItems}</b> Soft Skills aus, die Sie <b>regelmäßig zeigen</b> und <b>praxisnah belegen</b> können. Markieren Sie die passenden Kästchen; mehr als ${i?.maxItems} sind nicht möglich. <br/>Bevorzugen Sie Fähigkeiten, die Sie <b>in konkreten Situationen eingesetzt</b> haben (z. B. Projekte, Aufgaben, Erfolge). Lassen Sie Unzutreffendes frei; wählen Sie „Keine“ nur, wenn nichts passt.`)
};

/**
* | output |
* | --- |
* | "Select <b>up to {maxItems}</b> soft skills that you <b>regularly demonstrate</b> and <b>can prove with practical examples</b>. Mark the appropriate boxes; no..." |
*
* @param {Select_Up_ToInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const select_up_to = /** @type {((inputs: Select_Up_ToInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Select_Up_ToInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_select_up_to(inputs)
	return en_select_up_to(inputs)
});